import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		container: {
			alignSelf: 'stretch',
			flexGrow: 1,
			display: 'flex',
			flexDirection: 'column',
		},
		jobProfileContainer: {
			display: 'flex',
			flexDirection: 'column',
			flexGrow: 0,
			flexBasis: '100%',
			maxWidth: 670,
			alignSelf: 'center',
			[theme.breakpoints.down('sm')]: {
				maxWidth: 670,
			},
		},
		jobProfileMainContent: {
			display: 'flex',
			flexDirection: 'column',
			// width: '100%',
			marginBottom: '30px',
			padding: '0px 10px',
			// position: 'relative',
			// flexWrap: 'unset',
		},
		companyBadge: {
			maxWidth: '100%',
			width: 'auto',
			marginTop: theme.spacing(1),
			paddingLeft: 0,
		},
		companyBadgeAvatar: {
			border: '1px solid #ebebeb',
		},
		peopleBadgeCurrentPosition: {
			display: 'flex',
			flexDirection: 'row',
			flexWrap: 'nowrap',
			fontWeight: 500,
			fontSize: 16,
			lineHeight: '26px',
		},

		delimiter: {
			border: 'none',
			backgroundColor: theme.palette.grey[400],
			opacity: 0.5,
			height: 1,
			margin: `${theme.spacing(2)}px 0`,
		},

		pageTitleSection: {
			color: theme.palette.grey[800],
			fontSize: '22px',
			fontWeight: 300,
			marginTop: '10px',
			marginBottom: '10px',
		},

		chip: {
			margin: 2,
			background: '#e1e1f4',
			color: '#1B1A7C',
		},
		companyBadgeWrap: {
			maxWidth: '300px',
			width: 'auto',
		},
		jobHeaderSection: {
			display: 'flex',
			alignItems: 'center',
		},
		buttonsContainer: {
			display: 'flex',
			alignItems: 'center',
			flexFlow: 'row',
			marginLeft: 'auto',
		},
		btnLink: {
			cursor: 'pointer',
			fontSize: '14px',
			fontWeight: 400,
			color: '#1B1A7C',
			marginRight: '5px',
		},
		shareButton: {
			textTransform: 'none',
		},
		applyButton: {
			textTransform: 'none',
			marginLeft: '5px',
		},
		jobDescriptionItem: {
			color: '#989898',
			fontSize: '14px',
			fontWeight: 400,
			borderLeft: '2px solid #989898',
			// height: '12px',
			lineHeight: '15px',
			padding: '0px 20px 0px 10px',
			margin: '6px 0px',
		},
		salaryRange: {
			display: 'inline-block',
		},
		jobTitleSection: {
			marginTop: '35px',
		},
		jobTitle: {
			fontSize: '21px',
			fontWeight: 700,
		},
		jobImage: {
			display: 'block',
			width: '100%',
			height: '100%',
			maxWidth: '370px',
			maxHeight: '220px',
			objectFit: 'contain',
			marginLeft: 'auto',
			borderRadius: '10px',
			[theme.breakpoints.down('sm')]: {
				marginLeft: 'unset',
			},
		},
		infoContainer: {
			display: 'flex',
			flexFlow: 'column',
			marginTop: '8px',
		},
		labelText: {
			color: theme.palette.grey[900],
			fontSize: '16px',
			fontWeight: 700,
			marginBottom: '10px',
			marginTop: '10px',
		},
		jobDescriptionText: {
			whiteSpace: 'pre-line',
			color: theme.palette.grey[600],
			fontWeight: 300,
		},
		teamHeaderRoot: {
			// TODO: I need to review this class for adding mobile version css.
			// maxWidth: '650px',
			display: 'flex',
			'-webkit-box-shadow': '0px 2px 5px 0px rgba(0,0,0,0.2)',
			'-moz-box-shadow': '0px 2px 5px 0px rgba(0,0,0,0.2)',
			boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.2)',
			borderRadius: '5px',
			// overflow: 'hidden',
			// width: '100%',
			// [theme.breakpoints.up('sm')]: {
			// 	maxHeight: '250px',
			// },
		},
		teamHeadCont: {
			width: '100%',
			height: '100%',
			objectFit: 'cover',
		},
		teamResourceContainer: {
			height: '100%',
			overflow: 'hidden',

			'& img': {
				width: '100%',
				height: '100%',
				objectFit: 'cover',
				[theme.breakpoints.down('xs')]: {
					maxWidth: '300px',
				},
			},
		},
		teamHeadDescriptionRoot: {
			position: 'relative',
			width: '100%',
			backgroundColor: '#fff',
			display: 'flex',
			flexDirection: 'column',
			[theme.breakpoints.down('xs')]: {
				minHeight: '150px',
				height: 'auto',
			},
		},
		teamHeadTitle: {
			margin: '10px',
			textTransform: 'capitalize',
			color: theme.palette.grey[800],
			fontWeight: 700,
		},
		teamHeadDesc: {
			overflow: 'hidden',
			color: theme.palette.grey[600],
			fontWeight: 300,
			margin: '0 10px',
			display: '-webkit-box',
			'-webkit-line-clamp': 8,
			'-webkit-box-orient': 'vertical',
			[theme.breakpoints.down('xs')]: {
				'-webkit-line-clamp': 3,
			},
		},
		wisiwygContent: {
			'& *': {
				fontSize: '12px !important',
			},
		},
		cardImage: {
			objectFit: 'contain',
			display: 'block',
			margin: '0 auto',
			maxWidth: '100%',
			maxHeight: '100%',
		},
		video: {
			display: 'flex',
			'&:hover': {
				cursor: 'pointer',
			},
			position: 'relative',
			paddingTop: '56.25%' /* Player ratio: 100 / (1280 / 720) */,
			overflow: 'hidden',
		},
		teamSectionWrap: {
			display: 'flex',
			flexDirection: 'column',
			//width: '100%',
			//justifyContent: 'center',
			//alignItems: 'center',
			//paddingBottom: '20px',
		},
		aboutTeamSection: {
			marginBottom: '30px',
			maxWidth: '670px',
			padding: '10px',
			// height: '100%',
			// width: '100%',
			borderRadius: '5px',
			[theme.breakpoints.up('sm')]: {
				width: '650px',
			},
		},
		teamCardWrap: {
			display: 'flex',
			flexDirection: 'column',
			flexGrow: 0,
			flexBasis: '100%',
			maxWidth: 670,
			paddingLeft: '10px',
			paddingRight: '10px',
			alignSelf: 'center',
		},
		learnMoreBtn: {
			height: '25px',
			position: 'absolute',
			bottom: '5px',
			left: '5px',
			textTransform: 'none',
		},
		teamSectionTitle: {
			//display: 'flex',
			//flexDirection: 'column',
			color: theme.palette.grey[800],
			fontSize: '22px',
			fontWeight: 300,
			marginTop: '10px',
			marginBottom: '20px',
			maxWidth: 650,
		},
		teamSectionTitleMain: {
			marginLeft: 5,
			fontWeight: 700,
		},
		buttonRoot: {
			marginTop: '40px',
			marginBottom: '20px',
			paddingLeft: '10px',
		},
		saveBtn: {
			textTransform: 'none',
		},
		postButton: {
			width: '100%',
			height: theme.spacing(8),
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'center',
			color: '#ffffff',
			fontWeight: 700,
			fontSize: 16,
			backgroundColor: theme.palette.primary.main,
		},
		loader: {
			color: 'rgba(255, 255, 255)',
		},
		saveContainer: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-evenly',
			width: '100%',
			'& .saveContainerText': {
				lineHeight: '30px',
				fontSize: 16,
				cursor: 'default',
			},
		},
		chipSaveButton: {
			backgroundColor: '#fff',
			'&:hover': {
				cursor: 'default',
				backgroundColor: '#fff !important',
			},
		},
		player: {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100% !important',
			height: '100% !important',
			'& iframe': {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
			},
		},
		froalaEditorContainer: {
			display: 'flex',
			flexDirection: 'column',
		},
	})
